module.exports = __webpack_public_path__ + "cbe9009957e1ccd62fed2247933fcdde.jpg";